<template>
  <card v-loading="loadingReportData">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-uppercase text-muted ls-1 mb-1">Visualização</h6>
        <h5 class="h3 mb-0">Ticket Médio</h5>
      </div>
    </div>
    <bar-chart
      v-if="Object.keys(reportData).length > 0"
      :chart-data="chartData()"
      :extra-options="chartOptions"
    />
  </card>
</template>

<script>
import BarChart from "@/components/Charts/BarChart";

export default {
  name: 'average-ticket-card',
  components: {
    [BarChart.name]: BarChart,
  },
  data() {
    return {
      additionalData: [],
      filter: {},
      loadingReportData: false,
      reportData: [],
      reportDataTimeout: null,
      chartDataTypes: {
        'enterprises': 'Empresas',
        'managers': 'Gerentes Comerciais',
        'salesmen': 'Vendedores',
        'consultants': 'Colaboradores',
      },
      chartOptions: {
        locale: 'pt-BR',
        legend: {
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          multiline: true,
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
              const value = tooltipItem.yLabel;
              if (isNaN(value)) {
                return datasetLabel + ': Dado não disponível';
              }
              const countDataItem = this.additionalData[tooltipItem.index];
              const additionalValue = datasetLabel === 'Quantidade'
                ? parseInt(countDataItem.value).toLocaleString('pt-BR')
                : countDataItem.value;

              const formattedValue = datasetLabel === 'Quantidade'
                ? parseInt(value).toLocaleString('pt-BR')
                : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

              return ['Quantidade: ' + additionalValue, 'Valor: ' + formattedValue];
            }.bind(this),
          },
        }
      }
    }
  },
  props: {
    startDate: {
      required: true
    },
    endDate: {
      required: true
    },
  },
  methods: {
    debouncedGetReportData(){
      if (this.reportDataTimeout) clearTimeout(this.reportDataTimeout);

      this.reportDataTimeout = setTimeout(() => this.getReportData(), 500)
    },
    async getReportData() {
      this.loadingReportData = true;
      let serviceParams  = { q: {} };

      if (this.startDate) serviceParams.q.start_date = this.startDate;
      if (this.endDate)   serviceParams.q.end_date = this.endDate;

      try {
        const response = await this.$http.secured.get("/api/v1/report/average_ticket", {
          params: { service_params: serviceParams }
        })
        this.reportData = response.data;

        this.additionalData = Object.keys(this.chartDataTypes).map((el) => ({
          label: this.chartDataTypes[el],
          value: this.reportData[`${el}_count`],
        }));
      } catch (error) {
        console.warn("[AverageTicketCard][getReportData] Error getting report data", error);
      }
      this.loadingReportData = false;
    },
    chartData() {
      if (Object.keys(this.reportData).length == 0) return;

      const data = Object.keys(this.chartDataTypes).map((el) => this.reportData[el])
      const labels = Object.values(this.chartDataTypes)

      const countData = Object.keys(this.chartDataTypes).map((el) => {
        const countKey = `${el}_count`;
        return this.reportData[countKey];
      });

      this.additionalData = countData.map((value, index) => ({
        value: value,
      }));

      const datasets = [
        {
          data: data,
          label: 'Valor',
        },
      ];

      return {
        datasets: datasets,
        labels: labels,
      };
    }
  },
  watch: {
    startDate: {
      handler: function (val, oldVal) {
        this.debouncedGetReportData();
      },
    },
    endDate: {
      handler: function (val, oldVal) {
        this.debouncedGetReportData();
      },
    },
  }
}
</script>

<style>
</style>
